import React from 'react'
import { useIntl } from 'react-intl'

export const injectIntl = WrappedComponent => {
  const WithIntl = props => {
    const intl = useIntl()
    return <WrappedComponent {...props} intl={intl} />
  }
  WithIntl.displayName = `InjectIntl(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`
  WithIntl.WrappedComponent = WrappedComponent
  return WithIntl
}
